/*
 * @Description: 
 * @Author: pu.yuchun
 * @LastEditors: pu.yuchun
 * @Date: 2019-05-15 09:34:08
 * @LastEditTime: 2019-09-27 11:14:04
 */
/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-pgc-渠道管理
 */
'use strict';
angular.module("channelManagementModule",[]).
controller('channelManagementCtrl', ['$scope','httpService','modalDialog',function($scope,httpService,modalDialog){
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus(){
    	
        $scope.status = {
            inputData:''
        };
        $scope.page = {
            "CURRPAGE": 1,
            "PAGESIZE": 20,
            "ITEMCOUNT": 0
        };
        $scope.platformName = "石榴云";
        $scope.data = {
            listData: [],
            selectedArray: [], //选中的数据
        };
        initDropDownList();
    };

    function initData(){
        requestData();
    };
    /**
     * [initDropDownList description] 初始化下拉菜单
     * @return {[type]} [description]
     */
    function initDropDownList() {
        $scope.status.statusOptions = [{
            name: "全部状态",
            value: ''
        }, {
            name: "停用",
            value: 0
        }, {
            name: "启用",
            value: 1,
        }];
        $scope.status.selectedStatus = angular.copy($scope.status.statusOptions[0]);
    };
    /**
     * [requestData description] 初始数据
     * @return {[type]} [description]
     */
    $scope.requestData = function() {
        requestData();
    };
    function requestData() {
        $scope.data.selectedArray = [];
        var params = {
        	status:$scope.status.selectedStatus.value,
            currPage: $scope.page.CURRPAGE,
            pageSize: $scope.page.PAGESIZE
        };
        $scope.loadingPromise = httpService.http("/mcnadmin/admin/channel/channels.do", params, "post").then(function(data) {
            $scope.data.listData = data.data.ldata;
            $scope.page = {
                CURRPAGE: data.data.startPage,
                PAGESIZE: data.data.pageSize,
                ITEMCOUNT: data.data.totalResults,
                PAGECOUNT: data.data.totalPages
            };
        });
    };
    /**
     * [selectDoc description] 单选
     * @param  {[type]} item [description] 当前数据
     * @return {[type]}      [description]
     */
    $scope.selectDoc = function(item) {
        var index = $scope.data.selectedArray.indexOf(item);
        index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
    };
    /**
     * [selectPanel description] 全选当前面板的稿件
     * @param  {[type]} items [description] 当前面板
     * @return {[type]}       [description]
     */
    $scope.selectPanel = function(items) {
        if ($scope.data.listData.length > 0 && $scope.data.selectedArray.length == $scope.data.listData.length) {
            $scope.data.selectedArray = [];
        } else {
            $scope.data.selectedArray = [].concat($scope.data.listData);
        }
    };
    
    /**
     * [synChannel description] 同步渠道
     * @param  {[type]} null [description]
     * @return {[type]}      [description]
     */
    $scope.synChannel = function() {
        modalDialog.backConfirmModal("渠道同步", "确认与"+$scope.platformName+"同步？", function() {
	    	$scope.loadingPromise = httpService.http("/mcnadmin/admin/channel/synChannel.do", "", "post").then(function(data) {
	    		modalDialog.alertType('','同步成功','success');
	    		requestData();
	        });
        });
    };
    /**
     * [synChannel description] 启用渠道
     * @param  {[type]} null [description]
     * @return {[type]}      [description]
     */
    $scope.openChannel = function() {
    	var params = {
    		status:1,
    		ids:angular.packageIds($scope.data.selectedArray,",","id")
    	}
    	
        modalDialog.backConfirmModal("启用渠道", "确认启用已选渠道？", function() {
	    	$scope.loadingPromise = httpService.http("/mcnadmin/admin/channel/changeStatus.do", params, "post").then(function(data) {
	    		modalDialog.alertType('','启用成功','success');
	    		requestData();
	        });
        });
    };
    
    /**
     * [synChannel description] 停用渠道
     * @param  {[type]} null [description]
     * @return {[type]}      [description]
     */
    $scope.closeChannel = function() {
    	var params = {
    		status:0,
    		ids:angular.packageIds($scope.data.selectedArray,",","id")
    	}
        modalDialog.backConfirmModal("停用渠道", "确认停用已选渠道？", function() {
	    	$scope.loadingPromise = httpService.http("/mcnadmin/admin/channel/changeStatus.do", params, "post").then(function(data) {
	    		modalDialog.alertType('','停用成功','success');
	    		requestData();
	        });
        });
    };
}]);
